import * as AccordionPrimitives from "@radix-ui/react-accordion";
import classNames from "classnames";
import { CaretDown } from "components/icons/CaretDown";
import React, { ReactNode } from "react";
import { InfoItem } from "../InfoItem/InfoItem";

export const ItemGrid = ({ children }: { children: ReactNode }) => (
  <span className="t-grid t-gap-5 t-grid-cols-2">{children}</span>
);

export const Trigger = ({
  children,
  arrowPosition = "right",
  showArrow = true,
  ...props
}: {
  children: ReactNode;
  arrowPosition?: "left" | "right";
  showArrow?: boolean;
} & AccordionPrimitives.AccordionTriggerProps &
  React.RefAttributes<HTMLButtonElement>) => {
  const arrow = !props.disabled && (
    <span className="group-data-state-open:-t-rotate-180 group-data-state-closed:t-rotate-0 t-text-neutral t-transform t-transition t-duration-300 t-ease-in-out">
      <CaretDown />
    </span>
  );

  return (
    <AccordionPrimitives.Trigger asChild {...props}>
      <button
        className={classNames(
          "all:unset t-group t-select-none t-flex t-text-subtext t-p-4 t-gap-2 t-items-center after:t-content-[''] after:data-state-closed:t-border-surface-transparent after:data-state-open:t-border-neutral-10 after:t-border-0 after:t-border-solid after:t-border-b after:t-block after:t-absolute after:t-bottom-0 after:t-w-[calc(100%-32px)] after:t-mx-4 after:t-right-0 t-w-full t-relative",
          {
            "t-justify-between t-capitalize": arrowPosition === "right",
            "t-justify-start": arrowPosition === "left",
          }
        )}
      >
        {arrowPosition === "left" && showArrow && arrow}
        {children}
        {arrowPosition === "right" && showArrow && arrow}
      </button>
    </AccordionPrimitives.Trigger>
  );
};

export const Item = (
  props: AccordionPrimitives.AccordionItemProps &
    React.RefAttributes<HTMLDivElement> & { isActive?: boolean }
) => {
  return (
    <AccordionPrimitives.Item
      {...props}
      className={classNames("t-rounded-lg t-border t-border-solid", {
        "t-animate-active": props.isActive,
        "t-border-neutral-10": !props.isActive,
      })}
    />
  );
};

export const Content = (
  props: AccordionPrimitives.AccordionContentProps &
    React.RefAttributes<HTMLDivElement>
) => {
  return (
    <AccordionPrimitives.Content
      {...props}
      className={classNames("t-p-4", props.className || "")}
    />
  );
};

export const Accordion = {
  ...AccordionPrimitives,
  Item,
  Trigger,
  Content,
  ItemGrid,
  InfoItem,
  RawTrigger: AccordionPrimitives.Trigger,
  RawContent: AccordionPrimitives.Content,
  RawItem: AccordionPrimitives.Item,
};
